import React, { Fragment, useEffect, useState, useRef } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import "./style/taxCollections.css";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { useFilePicker } from "use-file-picker";
import SignupSchema from "./TaxCollectionFormValidations";
import PopupModal from "../../../../Components/PopupModal";
import { fallBackImage } from "../../../../utils/fallbackImage";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { doPostFormData, doPut } from "../../../../utils/request";
import {
  PlusOutlined,
  CloseCircleFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import * as dropDownActions from "../../../../actionCreators/DropDown";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";
import { FormPickerField } from "../../../../Components/FormPickerField/FormPickerField";
import {
  Button,
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Select,
  Image,
  Typography,
} from "antd";

const { TextArea } = Input;
const { REACT_APP_SNG_STORAGE_SERVER_URL } = process.env;
const TaxCollectionForm = ({
  data,
  isInspector,
  getBanks,
  getBranches,
  banks,
  branches,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef();
  const history = useHistory();
  const [error, setError] = React.useState(null);
  const [documents, setDocuments] = useState([]);
  const [remainingAmount, setRemainingAmount] = useState(
    data?.current_year_tax
  );
  const [rejectionNote, setRejectionNote] = React.useState("");
  const [showRejectModal, setShowRejectModal] = React.useState(false);
  const [showWarning, setShowWarning] = React.useState(false);
  const [showApproveModal, setShowApproveModal] = React.useState(false);
  const [amountPaid, setAmountPaid] = useState(data?.total_tax);
  const [receipt, setReceipt] = useState(data?.receipt_number);
  const [dueDate, setDueDate] = useState(
    data?.due_date ? moment(data?.due_date) : ""
  );
  const [issueDate, setIssueDate] = useState(
    data?.created_at ? moment(data?.created_at) : ""
  );
  const [paymentDate, setPaymentDate] = useState(
    data?.payment_date ? moment(data?.payment_date) : ""
  );
  const [bankName, setBankName] = useState(data?.bank?.name);
  const [branchName, setBranchName] = useState(data?.bank_branch?.name);
  const [arrears, setArrears] = useState(data?.arrears);
  const [remarks, setRemarks] = useState(null);
  const [showRemarks, setShowRemarks] = useState(false);
  const [remarksError, setRemarksError] = useState(false);
  const [loader, setLoading] = useState(false);
  const [ShowError, setShowError] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [bankId, setBankId] = useState(data?.bank?.id);
  const [branchId, setBranchId] = useState(data?.bank_branch?.id);

  let disable = true;
  if (!isInspector) {
    disable = true;
  } else {
    disable =
      data.status == "PAID" &&
      (data.approval_status === null || data.approval_status === "approved");
  }
  const [openFileSelector, { filesContent, plainFiles, loading }] =
    useFilePicker({ multiple: true, accept: "image/*" });

  useEffect(() => {
    let temp = [...documents];
    temp = temp.concat([...plainFiles]);
    setDocuments(temp);
  }, [plainFiles]);
  useEffect(() => {
    if (data?.documents?.length > 0) {
      let temp = [...documents];
      temp = temp.concat([...data?.documents]);
      setDocuments(temp);
    }
  }, [data]);
  useEffect(() => {
    getBanks();
    getBranches({ bank_id: data?.bank?.name });
  }, []);

  useEffect(() => {
    if (banks?.data) {
      var temp = [];
      for (let data of banks?.data) {
        let index = {
          key: data?.id,
          value: data?.name,
        };
        temp.push(index);
      }
      setBankList(temp);
    }
  }, [banks?.data]);
  useEffect(() => {
    if (branches.data) {
      var temp = [];
      for (let data of branches?.data) {
        let index = {
          key: data.id,
          value: data?.name,
        };
        temp.push(index);
      }
      setBranchList(temp);
    }
  }, [branches.data]);

  const updateTaxCollection = async (values, documents) => {
    setLoading(true);
    let bodyFormData = new FormData();
    bodyFormData.append("data", JSON.stringify(values));
    documents?.forEach((element) => {
      bodyFormData.append("file", element);
    });
    await doPostFormData(`/taxcollection/updateTaxCollection`, bodyFormData)
      .then((res) => {
        setLoading(false);
        setShowRemarks(false);
        history.goBack();
      })
      .catch((err) => {
        setLoading(false);
        setShowRemarks(false);
        setShowError(true);
      });
  };
  const approveRejectTax = async (values) => {
    setLoading(true);
    await doPut("/taxcollection/updateStatus", values)
      .then((res) => {
        setLoading(false);
        setShowApproveModal(false);
        setShowApproveModal(false);
        history.goBack();
      })
      .catch((err) => {
        setLoading(false);
        setShowApproveModal(false);
        setShowApproveModal(false);
        setShowError(true);
      });
  };
  const handleSubmitForm = async () => {
    setLoading(true);

    let formData = formRef.current.values;
    let values = {
      property_id: data?.property_id,
      receipt_number: formData?.receipt_number,
      payment_date: formData?.payment_date,
      bank: bankId,
      branch: branchId,
      remarks: remarks,
      ph10_id: data?.id,
    };
    let temps = documents.filter((e) => e.deleted);
    values["deleted_documents"] = JSON.stringify(temps);
    updateTaxCollection(values, documents);
  };
  const handleUpdateButtonClick = () => {
    let attachedDocs = documents.filter((e) => !e.deleted);
    if (attachedDocs.length <= 0) {
      setError("Please attach payment receipt.");
      return;
    }
    formRef.current.handleSubmit();
    setError(null);
    if (bankName && branchName && receipt && paymentDate) {
      setShowRemarks(true);
    }
  };
  const handleApproveButtonClick = () => {
    setShowApproveModal(true);
  };
  const handleRejectButtonClick = () => {
    setShowRejectModal(true);
  };
  const removeDocument = (index) => {
    let temps = [...documents];
    let temp = { ...temps[index] };
    if (temp.id != null) {
      temp["deleted"] = true;
      temps.splice(index, 1, temp);
    } else {
      temps.splice(index, 1);
    }
    setDocuments(temps);
  };
  const handleApproveRejectButtons = (status) => {
    let values = {};
    values["ph10_id"] = data?.id;
    if (status === "rejected") {
      values["approval_status"] = "rejected";
      values["rejected_note"] = rejectionNote;
      approveRejectTax(values);
    } else {
      values["approval_status"] = "approved";
      approveRejectTax(values);
    }
  };
  const handleRejectionNote = (e) => {
    setRejectionNote(e.target.value);
  };

  return (
    <Fragment>
      <Row>
        <Col span={12}>
          <Typography className="heading">
            Tax Collection /{" "}
            <b style={{ fontSize: "24px", color: "#2196F3" }}>
              {data?.serial_number}
            </b>
          </Typography>
        </Col>
        <Col span={12}>
          <div className="approval-button-section header-buttons">
            {data.status == "UNPAID" && !isInspector && (
              <span>WAITING FOR SUBMISSION</span>
            )}
            {data.approval_status == "rejected" && (
              <span
                style={{
                  marginRight: "15px",
                  color: "red",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                REJECTED
              </span>
            )}
            {data.approval_status == "approved" && (
              <span
                style={{
                  marginRight: "15px",
                  color: "green",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                APPROVED
              </span>
            )}
            {data.approval_status === null &&
              data.status == "PAID" &&
              !isInspector && (
                <>
                  <Button
                    className="reject-tax-collection-button"
                    type="ghost"
                    onClick={() => handleRejectButtonClick()}
                    icon={<CloseOutlined />}
                  >
                    REJECT
                  </Button>
                  <Button
                    className="approve-tax-collection-button"
                    type="default"
                    onClick={() => handleApproveButtonClick()}
                    icon={<CheckOutlined />}
                  >
                    APPROVE
                  </Button>
                </>
              )}
            {disable === false && (
              <Button
                className="approve-tax-collection-button"
                type="default"
                onClick={() => handleUpdateButtonClick()}
              >
                UPDATE PAYMENT
              </Button>
            )}
          </div>
        </Col>
      </Row>
      <Formik
        innerRef={formRef}
        validationSchema={SignupSchema}
        enableReinitialize={true}
        initialValues={{
          owner_name: data?.property_data?.property_owners
            .map((e) => e.name)
            .join(","),
          property_number: data?.property_id,
          serial_number: data?.serial_number,
          arrears:
            "RS. " + arrears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          receipt_number: receipt,
          issue_date: issueDate,
          due_date: dueDate,
          payment_date: paymentDate,
          year: data?.tax?.year,
          bank: bankName,
          branch: branchName,
          paid_amount:
            "RS. " +
            amountPaid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          remaining_amount: data?.remaining_amount,
          payment: data?.payment || "Full",
          remarks: data?.remarks,
          rejection_reason: data?.rejected_note,
          current_year_tax:
            "RS. " +
            data?.tax?.annual_tax
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        }}
      >
        {(props) => (
          <Form
            onFinish={props.handleSubmit}
            form={form}
            onValuesChange={(val) => {
              if (val?.bank) {
                form.setFieldsValue({ ...form.getFieldsValue, branch: "" });
              }
            }}
          >
            {error && (
              <Row span={24}>
                <span style={{ color: "red" }}>{error}</span>
              </Row>
            )}
            {data.approval_status == "rejected" && data.status == "PAID" && (
              <Row>
                <Col span={24} className="">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    name="rejection_reason"
                    labelText="Rejection Reason"
                    className="text-field"
                    disabled={true}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="property_number"
                  labelText="Property Number"
                  className="text-field"
                  disabled={true}
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="serial_number"
                  labelText="Serial No."
                  className="text-field"
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="owner_name"
                  errorMessage={props?.errors?.owner_name}
                  labelText="Owner Name"
                  disabled={true}
                  className="text-field"
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="year"
                  labelText="Financial Year"
                  disabled={true}
                  className="picker-field"
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="receipt_number"
                  onChange={(data) => {
                    setReceipt(data.target.value);
                    props.setFieldValue("receipt_number", data.target.value);
                  }}
                  errorMessage={props?.errors?.receipt_number}
                  labelText="Receipt No"
                  disabled={disable}
                  className="text-field"
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={DatePicker}
                  component={FormPickerField}
                  name="due_date"
                  placeholder=""
                  errorMessage={props?.errors?.due_date}
                  labelText="Due Date"
                  disabled={true}
                  className="picker-field"
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  placeholder=""
                  name="issue_date"
                  disabled={true}
                  labelText="Issue Date"
                  InputType={DatePicker}
                  className="picker-field"
                  component={FormPickerField}
                  errorMessage={props?.errors?.issue_date}
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={DatePicker}
                  component={FormPickerField}
                  onChange={(data) => {
                    setPaymentDate(data.format("YYYY-MM-DD"));
                    props.setFieldValue(
                      "payment_date",
                      data?.format("YYYY-MM-DD")
                    );
                  }}
                  name="payment_date"
                  placeholder=""
                  errorMessage={props?.errors?.payment_date}
                  labelText="Payment Date"
                  disabled={disable}
                  className="picker-field"
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Select}
                  options={bankList}
                  component={FormInputField}
                  name="bank"
                  errorMessage={props?.errors?.bank}
                  labelText="Bank"
                  onChange={(data) => {
                    setBankName(data);
                    for (let temp of bankList) {
                      if (data === temp?.value) {
                        getBranches({ bank_id: temp.value });
                        setBankId(temp?.key);
                      }
                    }
                    props.setFieldValue("bank", data);
                    //  props.setFieldValue("branch", "");
                  }}
                  disabled={disable}
                  className="picker-field"
                  loading={banks?.loading}
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Select}
                  value={branchName}
                  component={FormInputField}
                  name="branch"
                  options={branchList}
                  errorMessage={props?.errors?.branch}
                  labelText="Bank Branch"
                  onChange={(data) => {
                    setBranchName(data);
                    for (let temp of branchList) {
                      if (data === temp?.value) {
                        setBranchId(temp?.key);
                      }
                    }
                    props.setFieldValue("branch", data);
                  }}
                  disabled={disable}
                  className="picker-field"
                  active={true}
                  loading={branches?.loading}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="current_year_tax"
                  errorMessage={props?.errors?.current_year_tax}
                  labelText="Current Year Tax"
                  disabled={true}
                  className="text-field"
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="arrears"
                  labelText="Arrears"
                  disabled={true}
                  className="text-field"
                  // onChange={onChangeArrears}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="paid_amount"
                  labelText="Total Payable"
                  disabled={true}
                  className="text-field"
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="remaining_amount"
                  labelText="Remaining Amount"
                  disabled={true}
                  className="text-field"
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="payment"
                  errorMessage={props?.errors?.payment}
                  labelText="Payment"
                  disabled={true}
                  className="picker-field"
                />
              </Col>
            </Row>
            <Row>Document Proof</Row>
            <Row>
              {documents &&
                documents.map((image, index) => {
                  let url = image.ph10_id
                    ? `${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`
                    : !image?.deleted
                    ? URL?.createObjectURL(image)
                    : "";
                  return (
                    !image.deleted && (
                      <div
                        key={image.name + index}
                        className="image-parser"
                        style={{ margin: 10 }}
                      >
                        <Image
                          width={200}
                          height={200}
                          className="image"
                          src={url}
                          fallback={fallBackImage}
                        />
                        {disable === false && (
                          <CloseCircleFilled
                            onClick={() => {
                              removeDocument(index);
                            }}
                            style={{
                              position: "absolute",
                              top: 5,
                              right: 5,
                            }}
                          />
                        )}
                        <span
                          style={{
                            position: "absolute",
                            bottom: 0,
                            width: "100%",
                            backgroundColor: "#34343438",
                            fontWeight: 600,
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          {moment(image.created_at).format("DD-MM-YYYY hh:mm")}
                        </span>
                      </div>
                    )
                  );
                })}
              {!disable && (
                <PlusOutlined
                  style={{
                    marginLeft: !documents || documents.length == 0 ? "50%" : 0,
                  }}
                  onClick={() => openFileSelector()}
                />
              )}
            </Row>
            <Row>
              {(!documents || documents.length == 0) && (
                <span
                  style={{
                    marginTop: 20,
                    marginBottom: 150,
                    fontWeight: "bold",
                  }}
                >
                  No proof attached
                </span>
              )}
            </Row>
          </Form>
        )}
      </Formik>
      <PopupModal
        title={"Approve Tax Collection"}
        centered
        visible={showApproveModal}
        onOk={() => handleApproveRejectButtons("approved")}
        onCancel={() => setShowApproveModal(false)}
        footer={[
          <Button
            key="cancel"
            type="link"
            onClick={() => setShowApproveModal(false)}
          >
            CANCEL
          </Button>,
          <Button
            key="submit"
            type="link"
            loading={loader}
            onClick={() => {
              handleApproveRejectButtons("approved");
            }}
          >
            APPROVE
          </Button>,
        ]}
      >
        <p>Are you sure you want to approve this payment?</p>
      </PopupModal>
      <PopupModal
        title={"Reject reason"}
        centered
        visible={showRejectModal}
        onCancel={() => setShowRejectModal(false)}
        footer={[
          <Button
            key="cancel"
            type="link"
            onClick={() => setShowRejectModal(false)}
          >
            CANCEL
          </Button>,
          <Button
            key="submit"
            type="link"
            loading={loader}
            onClick={() => {
              if (rejectionNote === "") {
                setShowWarning(true);
              } else {
                handleApproveRejectButtons("rejected");
              }
            }}
          >
            REJECT
          </Button>,
        ]}
      >
        <TextArea
          rows={4}
          name="rejection-note"
          placeholder="Note"
          onChange={handleRejectionNote}
          value={rejectionNote}
          status={showWarning ? "error": ""}
        />
        {showWarning ? (
          <Typography style={{ color: "red" }}>
            Enter a valid rejection reason.
          </Typography>
        ) : (
          <></>
        )}
      </PopupModal>
      <PopupModal
        title={"Add Remarks"}
        centered
        visible={showRemarks}
        onCancel={() => setShowRemarks(false)}
        footer={[
          <Button
            key="submit"
            type="link"
            onClick={() => {
              setShowRemarks(false);
            }}
          >
            CANCEL
          </Button>,
          <Button
            key="submit"
            type="link"
            loading={loader}
            onClick={() => {
              if (remarks === null) {
                setRemarksError(true);
              } else {
                handleSubmitForm();
              }
            }}
          >
            ADD
          </Button>,
        ]}
      >
        <TextArea
          rows={2}
          name="Remarks"
          placeholder="Remarks"
          onChange={(e) => setRemarks(e.target.value)}
          value={remarks}
          status={remarksError ? "error" : ""}
        />
        {remarksError ? (
          <Typography style={{ color: "red" }}>
            Remarks cannot be empty!
          </Typography>
        ) : (
          <></>
        )}
      </PopupModal>
      <PopupModal
        title={"Error"}
        centered
        visible={ShowError}
        onCancel={() => setShowError(false)}
        footer={[
          <Button
            key="button"
            type="link"
            onClick={() => {
              setShowError(false);
            }}
          >
            OK
          </Button>,
        ]}
      >
        An error appears while performing this process. Please try again.
      </PopupModal>
    </Fragment>
  );
};

// TaxCollectionForm.propTypes = {
//   data: PropTypes.object.isRequired,
//   updateTaxCollection: PropTypes.func.isRequired,
// };
// export default TaxCollectionForm;

const mapStateToProps = ({ dropDown: { banks, branches } }) => ({
  banks,
  branches,
});

const mapDispatchToProps = (dispatch) => ({
  getBanks: bindActionCreators(dropDownActions.getBanks, dispatch),
  getBranches: bindActionCreators(dropDownActions.getBranches, dispatch),
});

TaxCollectionForm.propTypes = {
  data: PropTypes.object.isRequired,
  updateTaxCollection: PropTypes.func.isRequired,
  getBanks: PropTypes.func.isRequired,
  getBranches: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaxCollectionForm);
